import React from "react";
import DesktopHeader from "../club/responsive/DesktopHeader";
import MobileHeader from "../club/responsive/MobileHeader";

const ClubTendersHeader = ({
  isMobile,
  transferWindowLoading,
  transferWindow,
  formatDateRange,
  dropdownRef,
  searchInputRef,
  searchQuery,
  setSearchQuery,
  handleTransferWindowDropdownToggle,
  countries,
  selectedCountry,
  isTransferWindowDropdownOpen,
  filteredCountries,
  handleCountrySelect,
  canCreateTenders,
  navigate,
  activeMainTab,
  setActiveMainTab,
  searchTerm,
  handleSearchChange,
  setShowFilterModal,
  hasActiveFilters,
  clearAllFilters,
  sortBy,
  handleSortChange,
  filters,
  handleFilterChange,
}) => {
  if (isMobile) {
    return (
      <MobileHeader
        transferWindowLoading={transferWindowLoading}
        transferWindow={transferWindow}
        formatDateRange={formatDateRange}
        dropdownRef={dropdownRef}
        searchInputRef={searchInputRef}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleTransferWindowDropdownToggle={handleTransferWindowDropdownToggle}
        countries={countries}
        selectedCountry={selectedCountry}
        isTransferWindowDropdownOpen={isTransferWindowDropdownOpen}
        filteredCountries={filteredCountries}
        handleCountrySelect={handleCountrySelect}
      />
    );
  }

  return (
    <DesktopHeader
      transferWindowLoading={transferWindowLoading}
      transferWindow={transferWindow}
      formatDateRange={formatDateRange}
      dropdownRef={dropdownRef}
      searchInputRef={searchInputRef}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleTransferWindowDropdownToggle={handleTransferWindowDropdownToggle}
      countries={countries}
      selectedCountry={selectedCountry}
      isTransferWindowDropdownOpen={isTransferWindowDropdownOpen}
      filteredCountries={filteredCountries}
      handleCountrySelect={handleCountrySelect}
      canCreateTenders={canCreateTenders}
      navigate={navigate}
      activeMainTab={activeMainTab}
      setActiveMainTab={setActiveMainTab}
      searchTerm={searchTerm}
      handleSearchChange={handleSearchChange}
      setShowFilterModal={setShowFilterModal}
      hasActiveFilters={hasActiveFilters}
      clearAllFilters={clearAllFilters}
      sortBy={sortBy}
      handleSortChange={handleSortChange}
      filters={filters}
      handleFilterChange={handleFilterChange}
    />
  );
};

export default ClubTendersHeader;

